import { Row } from 'reactstrap';
import { IngestState } from '../../features/ingest/ingestSlice';
import Upload from './Upload';
import Progress from './Progress';
import Mapping from './Mapping';
import Report from './VerificationReport';

const content = (state: IngestState) => {
  if (state.progress != null) {
    return <Progress {...state.progress}></Progress>;
  }
  if (state.mapping != null) {
    return <Mapping {...state.mapping}></Mapping>;
  }
  if (state.verification != null) {
    return <Report {...state.verification}></Report>;
  }
  return <Upload {...state}></Upload>;
};

export default (props: IngestState) => {
  return (
    <div className="m-4">
      <h2 className="mb-4">Upload Transaction File</h2>
      <Row className="justify-content-sm-start ml-2" />
      {content(props)}
    </div>
  );
};
